<div class="close-button" [mat-dialog-close]="false">
  <img src="assets/svg/closeButton.svg">
</div>
<div class="main-delete">

  <div class="text-part">
    <h3 class="text-part-title">{{ getTranslatedText(title) }}</h3>
    <span>{{ getTranslatedText(description) }}</span>
  </div>
    <div class="action-part">
      <button class="option-cancel option-shared" [mat-dialog-close]="false"> {{ getTranslatedText(cancelButtonText) }}</button>
      <button class="option-delete option-shared" [mat-dialog-close]="true">{{ getTranslatedText(confirmButtonText) }}</button>
    </div>
</div>
